import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';

export function ReasonDialog({
  open, onOpenChange, onConfirm, title, description, itemName = '',
  confirmLabel = 'Konfirmasi', confirmClassName = 'bg-red-600 hover:bg-red-700',
  loading = false, testId = 'reason-dialog',
}) {
  const [reason, setReason] = useState('');
  const tooShort = reason.trim().length < 3;

  const close = (v) => { if (!v) setReason(''); onOpenChange(v); };

  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent className="max-w-md" data-testid={testId}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        {itemName && <p className="font-semibold text-sm bg-slate-100 p-2 rounded" data-testid={`${testId}-item`}>{itemName}</p>}
        <div className="space-y-1">
          <Label htmlFor={`${testId}-reason`}>Alasan <span className="text-red-600">*</span></Label>
          <Textarea
            id={`${testId}-reason`}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Tuliskan alasan (minimal 3 karakter)..."
            rows={3}
            data-testid={`${testId}-reason-input`}
          />
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={() => close(false)} disabled={loading} data-testid={`${testId}-cancel-btn`}>Batal</Button>
          <Button
            className={confirmClassName}
            disabled={loading || tooShort}
            onClick={async () => { await onConfirm(reason.trim()); setReason(''); }}
            data-testid={`${testId}-confirm-btn`}
          >
            {loading ? 'Memproses...' : confirmLabel}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
